import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled, { prop } from '@nobia/zeus-components/lib/styled'
import { trackEvent } from '@nobia/zeus-components/lib/analytics'
import Button from '@nobia/zeus-components/lib/buttons'
import { bindActionCreators, connect } from '@nobia/zeus-components/lib/redux'
import {
  addWishlist,
  removeWishlist,
} from '@nobia/zeus-components/lib/sharedState/actions'
import ProductCodeModal from '../../components/product-code-modal/ProductCodeModal'
import Intro from '../../components/intro/Intro'
import ProductList from '../../components/product-list/ProductList'

const AddProductButton = styled(Button)`
  position: fixed;
  bottom: 0;
  left: 0;
  margin-bottom: 0;
  font-size: 24px;
  padding: 40px 0;

  &:hover {
    background-color: ${prop('theme.colors.primary')} !important;
  }
`

const trackAnalyticsEvent = () => {
  trackEvent('MC-ESH Add Product', 'MC-ESH Click', 'Add Product Trigged')
}

class LandingPage extends Component {
  state = {
    showProductCodeModal: false,
  }

  toggleProductCodeModal = () => {
    this.setState({ showProductCodeModal: !this.state.showProductCodeModal })
  }

  clickHandler = () => {
    this.toggleProductCodeModal()
    trackAnalyticsEvent()
  }

  render() {
    return (
      <div>
        {this.props.wishlist.length === 0 && <Intro />}
        {this.props.wishlist.length > 0 && (
          <ProductList
            wishlist={this.props.wishlist}
            handleRemove={this.props.removeFromWishlist}
          />
        )}
        <AddProductButton kind="primary" block onClick={this.clickHandler}>
          ADD PRODUCT
        </AddProductButton>
        <ProductCodeModal
          open={this.state.showProductCodeModal}
          handleClose={this.toggleProductCodeModal}
          onProductFetch={this.props.addToWishlist}
        />
      </div>
    )
  }
}

LandingPage.propTypes = {
  wishlist: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  addToWishlist: PropTypes.func.isRequired,
  removeFromWishlist: PropTypes.func.isRequired,
}

LandingPage.defaultProps = {
  wishlist: [],
}

const mapStateToProps = state => ({
  wishlist: state.wishlist,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addToWishlist: addWishlist,
      removeFromWishlist: removeWishlist,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LandingPage)
